<template>
    <div id="js-go-top" class="go_top" @click="goToTop()" data-jest="btn-go-top">
        <img :src="imgSrc" :alt="btnText">
    </div>
</template>

<script>
import {getClickAllEvent} from "../../util/Ga4EventUtil.js";

export default {
    name: "BtnGoToPageTop",
    props: {
        /**
         * 画像URL
         */
        imgSrc: {
            type: String,
            required: true
        },
        /**
         * ボタンテキスト
         */
        btnText: {
            type: String,
            required: true
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll, {
            capture: true
        })
    },
    unmounted() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        /**
         * スクロール値を測ってTOPへ戻るボタンの表示を制御する
         */
        onScroll() {
            //ある一定の高さまでスクロールされたらback_to_topを表示、そうでないときは非表示
            const btn = document.getElementById('js-go-top');
            const scrollTop = document.documentElement.scrollTop
            if (scrollTop > 200) {
                btn.classList.add("is-show")
            } else {
                btn.classList.remove("is-show")
            }
        },
        /**
         * click allイベントを送信し
         * ページ上部へスクロールする
         */
        goToTop() {
            getClickAllEvent('', this.btnText)
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style scoped lang="scss">
@use "../../../scss/v2/base/variables";
@use "sass:math";
$deviceWidth: 750px;

.go_top {
    opacity: variables.$opacity-0;
    transition: opacity 0.2s, transform 0.8s;
    width: math.percentage(math.div(158px, $deviceWidth));
    right: 7px;
    bottom: 7px;
    position: fixed;
    z-index: 200;
    &.is-show {
        opacity: variables.$opacity-100;
    }
}

</style>
